<template>
    <!-- form to add file on single -->
    <v-form v-model="isValid" ref="form" @submit.prevent=''>
        <v-container grid-list-xs>
            <v-layout wrap>
                <v-flex xs12 class="text-xs-center">
                    <v-btn
                        @click.native="openInput"
                        color="primary"
                        outline
                        round
                    >
                        {{file_name}}
                        <v-icon right>cloud_upload</v-icon>
                    </v-btn>
                    <!-- hidden input onclick btn simulate click on this input -- for style reasons -->
                    <input type="file" ref="fileInput" @change="UploadFile" style="display:none"/>
                </v-flex>
                <v-flex xs12>
                    <v-text-field label="Nom" v-model="model.label" :rules="rules.name" required autofocus></v-text-field>
                </v-flex>
            </v-layout>
        </v-container>
    </v-form>
</template>

<script>
export default {
    props: {
        params:{
            required: false
        }
    },
    data() {
        return {
            title:      'Ajouter un fichier',
            icon:       'file_upload',
            warning:    false,
            isValid:    false,
            disableEnter: false,
            model: {
                label: ''
            },
            file:'',
            rules: {
                name: [
                    (v) => !!v || 'Nom du fichier obligatoire',
                ],
            },
            file_name: 'Choisir un fichier',
            tags: []
        }
    },
    methods: {
        // when file chage in input
        UploadFile(event) {
            this.file = event.target.files[0]
            this.file_name = this.file.name
            this.model.label = this.file.name.split('.')[0]
        },
        // on click on btn -- click on hidden input
        openInput(){
            this.$refs.fileInput.click()
        },
        // when form is validate
        onValidate() {
            if(this.$refs.form.validate()) {
                this.attachment = this.file
                // create data object
                let data = new FormData()
                // put file & size inside (resize on back)
                data.append('file', this.attachment)
                data.append('size', 750)
                // post file
                this.axios.post(`/api/${this.params.entity}/${this.$route.params.id}/file`, data, {
                headers: {
                     'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    // modify the file with name
                    this.axios.put(`/api/files/${response.data.id}`, this.model)
                    .then(response => {
                        this.$eventHub.$emit('reload-list')
                        this.$store.dispatch('updateSingleData', { key:'files_count', value:this.$store.state.single.data.files_count + 1 })
                        this.onClose()
                    })
                })
                .catch(error => {
                });
            }
        },

        onClose() {
            // reset the form on close
            if(this.$refs.form) {
                this.$refs.form.reset()
            }
            this.$eventHub.$emit('close-modal')
        },
    },
    mounted() {

    }
}
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/files/CreateFiles.vue